import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthService } from '../services/services/auth.services';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private configService = inject(ConfigService);

  constructor(private authService: AuthService) {}

  /**
   * Intercepta requisições HTTP para adicionar o token de autenticação.
   * @param request - A requisição HTTP original.
   * @param next - O próximo handler na cadeia de interceptors.
   * @returns Observable do evento HTTP.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    
    const apiUrl = this.configService.getCurrentApiUrl();
    const publicRoutes = [
      `${apiUrl}/login`,
      `${apiUrl}/refresh`,
      `${apiUrl}/token/refresh`
    ];


    if (publicRoutes.some(url => request.url.includes(url))) {
      return next.handle(request);
    }

    const token = this.authService.getAccessToken();
    
    if (token) {
      const clonedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(clonedRequest);
    }


    return next.handle(request);
  }
}
